import React, { ReactNode } from 'react'
import Footer from './Footer/Footer.tsx'
import MegaMenu from './MegaMenu/MegaMenu.tsx'
import { MegaMenu as MegaMenuType} from '../../models/interfaces/MegaMenu.interface.ts'
import { Footer as FooterType } from '../../models/interfaces/Footer.interface.ts'

type LandingPagesLayoutProps = {
    children: ReactNode
    megaMenu: MegaMenuType
    footer: FooterType
}

const LandingPagesLayout = ({ children, megaMenu, footer }: LandingPagesLayoutProps) => {
  return (
    <div>
      <MegaMenu {...{ megaMenu }} />
      <main id='main-page' className='content'>
        {children}
      </main>
      <Footer {...{ footer }} />
    </div>
  )
}

export default LandingPagesLayout
